<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="400px"
    :innerScroll="false"
    @close="onCancel"
    :loading="loadingBth"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="60px" v-loading="loading">
      <el-row>
        <el-col :span="24">
          <el-form-item label="得分:" prop="score">
            <el-input v-model.trim="addForm.score" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Array,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '作品得分';
    },
  },
  data() {
    return {
      loading: false,
      loadingBth: false,
      addForm: {
        monthCodeQuery: '',
        score: '',
        workJobs: '',
        workNo: '',
      },
      rules: {
        score: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { pattern: /^(?:1000(?:\.0{1,2})?|1000\.0{1,2}|[1-9]\d{0,2}(?:\.\d{1,2})?|0(?:\.\d{1,2})?)$/, message: '请输入0-1000内的数字(最多2位小数)' },
        ],
      },
    };
  },
  created() {
    if (this.rowData.length == 1) {
      this.$set(this.addForm, 'score', this.rowData[0].worksScore);
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingBth = true;
        let data = this.rowData.map((v) => {
          return {
            score: this.addForm.score,
            monthCodeQuery: v.monthCodeQuery,
            workJobs: v.workJobs,
            workNo: v.workNo,
            processType: v.processType,
          };
        });
        this.$q.newProduct
          .photographerPayrollUpdateScore({ data: data })
          .then((res) => {
            if (res.success) {
              let text = '编辑成功';
              this.$message.success(text);
              this.isVisible = false;
              this.$emit('success');
            }
          })
          .finally((_) => {
            this.loadingBth = false;
          });
      });
    },
    async init() {},
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 200px !important
>>> .el-input
  width 200px !important
</style>
